import React from 'react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-white py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Contact Us</h1>
          <p className="text-gray-600">Get in touch with us for any questions or support</p>
        </div>

        <div className="prose prose-gray max-w-none">
          <p className="text-gray-700 leading-relaxed mb-8">
            If you have any questions about our Policies, please contact us using the information below:
          </p>

          <div className="grid md:grid-cols-2 gap-8 mb-8">
            <div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Contact Information</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-medium text-gray-900 mb-2">Email</h3>
                  <p className="text-gray-700">
                    <a href="mailto:aashritha756@yahoo.com" className="text-blue-600 hover:text-blue-800 underline">
                      aashritha756@yahoo.com
                    </a>
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-medium text-gray-900 mb-2">Phone</h3>
                  <p className="text-gray-700">
                    <a href="tel:+919448128756" className="text-blue-600 hover:text-blue-800 underline">
                      +91 9448128756
                    </a>
                  </p>
                </div>
              </div>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Office Address</h2>
              <div className="text-gray-700 leading-relaxed">
                <p>Aashritha E Solutions</p>
                <p>Ground Floor, Surabhi Lotus Building</p>
                <p>Ambalpady Highway Junction</p>
                <p>Karnataka 576101</p>
                <p>India</p>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 p-6 rounded-lg border">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Business Hours</h2>
            <p className="text-gray-700 leading-relaxed">
              We strive to respond to all inquiries within 24-48 hours during business days.
              For urgent matters, please call us directly at the phone number provided above.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;